// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b1368bb9","453":"9ecef910","455":"072a85c9"}[chunkId] + ".chunk.js";
};